import { appendOutboundCampaignAttribution } from '@/lib/utils/outboundAttribution';
import Testimonial from './Testimonial';

const newsletters = [
  {
    name: 'All About Email',
    operator: 'Simon Harper',
    href: 'https://newsletter.allabout.email/',
    trackingContent: 'all_about_email_logo',
    logoSrc: '/for-newsletters/all-about-email.svg',
    width: 4096,
    height: 1614,
    artworkClassName: 'h-14 w-auto max-w-36 -translate-y-[10px]',
  },
  {
    name: 'Email Advice in Your Inbox',
    operator: 'Des Brown',
    href: 'https://www.emailadviceinyourinbox.com/',
    trackingContent: 'email_advice_in_your_inbox_logo',
    logoSrc: '/for-newsletters/email-advice-in-your-inbox.svg',
    width: 3665,
    height: 2079,
    artworkClassName: 'h-14 w-auto max-w-36 -translate-y-[9px]',
  },
  {
    name: 'HeyNews',
    operator: 'Eren & Cagri',
    href: 'https://heynews.co/',
    trackingContent: 'heynews_logo',
    logoSrc: '/for-newsletters/heynews.svg',
    width: 4096,
    height: 975,
    artworkClassName: 'h-auto w-full max-w-40 translate-y-[4px]',
  },
  {
    name: 'LetterTrader',
    operator: null,
    href: 'https://lettertrader.com/',
    trackingContent: 'lettertrader_logo',
    logoSrc: '/for-newsletters/lettertrader.svg',
    width: 219,
    height: 32,
    artworkClassName: 'h-auto w-full max-w-40 -translate-y-[1px]',
  },
  {
    name: 'Southpoint Access',
    operator: 'Wes Platt',
    href: 'https://soduwelikelocal.news/',
    trackingContent: 'southpoint_access_logo',
    logoSrc: '/for-newsletters/southpoint-access.svg',
    width: 2289,
    height: 2911,
    artworkClassName: 'h-14 w-auto max-w-14 -translate-y-[4px]',
  },
] as const;

export default function CustomerLogos() {
  return (
    <section
      aria-labelledby="customer-logos-heading"
      className="newsletter-customer-logos relative w-screen px-6 pt-8 pb-10 md:pb-12"
    >
      <div className="relative z-20 mx-auto max-w-6xl">
        <div className="flex items-center gap-4 md:gap-6">
          <span className="h-px flex-1 border-t border-nl-line" aria-hidden />
          <h2
            id="customer-logos-heading"
            className="m-0 text-center font-mono text-[11px] leading-tight font-medium tracking-[0.14em] text-nl-ink/60 uppercase"
          >
            Trusted by newsletter operators
          </h2>
          <span className="h-px flex-1 border-t border-nl-line" aria-hidden />
        </div>

        <div className="mt-5 grid snap-x snap-proximity auto-cols-[minmax(11rem,1fr)] grid-flow-col items-stretch overflow-x-auto overscroll-x-contain p-1">
          {newsletters.map(
            ({
              name,
              operator,
              href,
              trackingContent,
              logoSrc,
              width,
              height,
              artworkClassName,
            }) => (
              <div
                key={name}
                className="min-w-0 snap-start border-l border-nl-line first:border-l-0"
              >
                <a
                  href={appendOutboundCampaignAttribution(href, {
                    source: 'atrivial',
                    medium: 'referral',
                    campaign: 'customer_showcase',
                    content: trackingContent,
                  })}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={operator ? `Visit ${name}, by ${operator}` : `Visit ${name}`}
                  className="group flex min-h-20 items-center justify-center rounded-lg px-4 py-3 transition-colors hover:bg-nl-paper focus-visible:ring-2 focus-visible:ring-nl-brand focus-visible:ring-offset-2 focus-visible:outline-none md:rounded-none"
                >
                  <img
                    src={logoSrc}
                    alt={name}
                    className={`object-contain opacity-50 [filter:var(--nl-logo-filter)] transition-opacity group-hover:opacity-100 ${artworkClassName}`}
                    width={width}
                    height={height}
                    loading="lazy"
                    decoding="async"
                  />
                </a>
              </div>
            )
          )}
        </div>

        <Testimonial />
      </div>
    </section>
  );
}
